import { useDispatch } from "react-redux";
import { AppDispatch, useSelector } from "@/core/redux/store";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shared/components/ui/avatar";
import { DateRangePicker } from "@/shared/components/ui/date-range-picker/date-range-picker";
import type { DateRange } from "react-day-picker";
import { SelectProjectDropdown } from "@/shared/components/select-project-dropdown/select-project-dropdown";
import { setHeaderFilters } from "@/core/redux/slices/dashboard";

export default function ContentHeader() {
  const me = useSelector((state) => state.user.me);
  const dispatch = useDispatch<AppDispatch>();
  const headerFilters = useSelector((state) => state.dashboard.headerFilters);
  const userName =
    me?.firstName || me?.lastName ? `${me.firstName} ${me.lastName}` : "";

  const profilePictureUrl = me?.profilePictureUrl;

  const handleProjectChange = (value: string, itemType?: "folder" | "specification" | "all") => {
    dispatch(setHeaderFilters({ ...headerFilters, selectedProjectId: value, itemType: itemType ?? "all" }));
  };

  const handleDateRangeChange = (dateRange: DateRange | Date | undefined) => {
    dispatch(setHeaderFilters({ ...headerFilters, dateRange: dateRange }));
  };

  return (
    <div className="w-full my-[24px] flex items-center justify-between gap-[12px] h-[50px]">
      {/* LEFT: Avatar + User Info */}
      <div className="flex items-center gap-[14px] flex-1">
        <Avatar className="size-[48px] rounded-full">
          <AvatarImage
            src={profilePictureUrl || "https://github.com/shadcn.png"}
            alt={userName}
            className="rounded-full object-cover"
          />
          <AvatarFallback className="rounded-full">
            {me?.firstName?.charAt(0) ||
              me?.email?.charAt(0)?.toUpperCase() ||
              "U"}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col gap-[2px]">
          <div className="text-[18px] font-[700] text-[#0e121b] leading-[28px]">
            {userName || "User"}
          </div>
          <div className="text-[14px] font-[600] text-[#71717a] leading-[20px] tracking-[-0.3px]">
            Welcome back to Procright 👋
          </div>
        </div>
      </div>

      {/* RIGHT: Date Picker + Button */}
      <div className="flex items-center gap-[8px]">
        <SelectProjectDropdown
          value={headerFilters.selectedProjectId}
          onValueChange={handleProjectChange}
          labelClassName="max-w-[120px] truncate"
        />
        <DateRangePicker
          mode="range"
          value={headerFilters.dateRange}
          onChange={handleDateRangeChange}
          placeholder="Tarih Seç"
        />
      </div>
    </div>
  );
}
